<template>
  <div>
    <!-- 主展示区 -->
    <main-zone class="split-bottom"></main-zone>
    <!-- 副展示区 -->
    <second-zone />
    <!-- 精选企业展示区 -->
    <choice-comp-zone />
    <!-- 增值专区入口 -->
    <value-added-zone />
    <!-- 最新招聘岗位展示区 -->
    <new-job-zone />
  </div>
</template>

<script>
import MainZone from '@/components/mainzone'
import SecondZone from '@/components/secondzone'
import ChoiceCompZone from '@/components/choicecompzone'
import ValueAddedZone from '@/components/valueaddedzone'
import NewJobZone from '@/components/newjobzone'

export default {
  name: 'Home',
  components: {
    MainZone,
    SecondZone,
    ChoiceCompZone,
    ValueAddedZone,
    NewJobZone
  }
}
</script>

<style scoped>
.split-bottom {
  margin-bottom: 10px;
}
</style>
